/**
 * Visual — Symbol-Rechnungen.
 * Klassisches Muster: Symbol = unbekannte Zahl, finde sie.
 */
export const VISUAL = [
  { id: 'vis01', cat: 'visual', diff: 1,
    q: 'Wenn ★ = 5, was ist ★ + ★?', a: '10',
    hint: 'Einsetzen', exp: '5 + 5 = 10' },

  { id: 'vis02', cat: 'visual', diff: 1,
    q: 'Wenn ▲ = 7, was ist ▲ × 2?', a: '14',
    hint: 'Doppelt nehmen', exp: '7·2 = 14' },

  { id: 'vis03', cat: 'visual', diff: 2,
    q: 'Wenn ★ + ★ = 10, was ist ★ × ★?', a: '25',
    hint: 'Erst ★ finden', exp: '★ = 5, also 5·5 = 25' },

  { id: 'vis04', cat: 'visual', diff: 2,
    q: 'Wenn ▲ = 3 und ● = 4, was ist ▲ × ● + ▲?', a: '15',
    hint: 'Einsetzen', exp: '3·4 + 3 = 15' },

  { id: 'vis05', cat: 'visual', diff: 2,
    q: 'Wenn ♦ × 3 = 21, was ist ♦?', a: '7',
    hint: '21 ÷ 3', exp: '♦ = 7' },

  { id: 'vis06', cat: 'visual', diff: 3,
    q: 'Wenn □ + □ + ○ = 12 und □ + ○ + ○ = 15, was ist □?', a: '3',
    hint: 'Differenz: ○−□ = 3', exp: 'Diff zw. Gleichungen: ○−□=3 → einsetzen → □=3, ○=6' },

  { id: 'vis07', cat: 'visual', diff: 3,
    q: 'Wenn ♦ · 2 + ♦ = 21, was ist ♦?', a: '7',
    hint: '3♦ = 21', exp: '3♦ = 21 → ♦ = 7' },

  { id: 'vis08', cat: 'visual', diff: 3,
    q: 'Wenn ★ + ★ + ★ = 18 und ★ · ▲ = 24, was ist ▲?', a: '4',
    hint: '★ = 6', exp: '★ = 6, also ▲ = 24/6 = 4' },

  { id: 'vis09', cat: 'visual', diff: 3,
    q: 'Wenn ○ · ○ = 49 und ○ > 0, was ist ○?', a: '7',
    hint: 'Quadratwurzel', exp: '√49 = 7' },

  { id: 'vis10', cat: 'visual', diff: 4,
    q: 'Wenn ▲ + ● = 10, ● + ■ = 14, ■ + ▲ = 12. Was ist ●?', a: '6',
    hint: 'System mit 3 Gleichungen', exp: 'Summe aller: 2(▲+●+■) = 36 → ▲+●+■ = 18. ● = 18 − 12 = 6' },

  { id: 'vis11', cat: 'visual', diff: 2,
    q: 'Wenn ◆ × ◆ = 16 und ◆ > 0, was ist ◆ × 3?', a: '12',
    hint: '◆ erst, dann ·3', exp: '◆ = 4, 4·3 = 12' },

  { id: 'vis12', cat: 'visual', diff: 3,
    q: 'Wenn ☆·☆·☆ = 27, was ist ☆?', a: '3',
    hint: 'Kubikwurzel', exp: '³√27 = 3' },

  { id: 'vis13', cat: 'visual', diff: 4,
    q: 'Wenn 2◆ + 3◇ = 17 und ◆ + ◇ = 7, was ist ◆?', a: '4',
    hint: 'Einsetzungsverfahren', exp: '◇ = 7−◆, einsetzen: 2◆ + 3(7−◆) = 17 → −◆ + 21 = 17 → ◆ = 4' },

  { id: 'vis14', cat: 'visual', diff: 2,
    q: 'Wenn ◯ = 8, was ist ◯/2 + ◯/4?', a: '6',
    hint: 'Bruchteile addieren', exp: '4 + 2 = 6' },

  { id: 'vis15', cat: 'visual', diff: 3,
    q: 'Wenn ▲ − ● = 5 und ▲ + ● = 13, was ist ▲?', a: '9',
    hint: 'Gleichungen addieren', exp: '2▲ = 18 → ▲ = 9' },
];
